import { BaseError } from '../../_base/lang/BaseError';

export class ExpenseNotFoundError extends BaseError {}
